
<div class="dtf-olp" style="background-color: #E6E6E6;">
  <div class="container_dashboard" >
    <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
      
      <div class="example-button-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
          <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3" style="background-color: #00566A !important; color: white !important;">Statement Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4">Manage Bank Profile</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
          <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
        </mat-button-toggle-group>
        </div>
    </div> 
  </div>

    <div class="container_dashboard" >
        <div style=" padding-bottom: 21px;">
           <div class="cardlike">
                <h1>{{ 'statementpayment.header' | translate }}</h1>
              
                <br>
                <div style="font-size: large;">
                  <p> You may have upcoming <a href="{{this.baseRedirect}}/home/scheduledpayment"><span
                        style="font-weight: bold; color: #00566A;">Scheduled Payments</span></a>. Click here to view the details and
                    dates. &nbsp;
                    <span>
                      <button matIconButton disabled aria-label="Example icon button with an open in new tab icon"
                        style="background: transparent; border: none; box-shadow: none;">
                        <a href="{{this.baseRedirect}}/home/scheduledpayment"><mat-icon
                            style="color: #00566A; height: 21px;">open_in_new</mat-icon></a>
                      </button>
                    </span>
                  </p>
                </div>
              </div>
           
            <div class="container_dashboard">
              <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <!--Spinner on Login Load-->
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div>

                  <!-- Search Filters  -->
                  <div *ngIf="statementpaymentstep1">
                    <div class="row" style="display: flex;">
                      <div class="col-lg-5">
                        <div class="card" style="width: 95%; padding-bottom: 23px;">
                          <h5 style="font-weight: bold;">Select Bank Account</h5>
                          <p>Step 1: Select your preferred payment profile</p>
                          <div class="row">
                            <div class="col-lg-7 col-md-7 col-sm-2 col-6">
                              <mat-form-field class="dropdown" appearance="outline">
                                <mat-label>{{ 'onlinepayment.select1' | translate }}<span style="color: red;">*</span></mat-label>
                                <mat-select [(ngModel)]="selected" (ngModelChange)="onChange()">
                                  <mat-option *ngFor="let opt of dropDownList" [value]="opt.id">
                                    {{opt.selection}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-7">
                        <div class="card" style=" width: 96%; ">
                           <h5 style="font-weight: bold;">Search By :</h5>
                          <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-2 col-6" id="account-number-filter">
                              <p>{{ 'statementpayment.filter1' |
                                translate }}</p>
                              <div class="row">
                                <div class="col">
                                  <mat-form-field appearance="outline" style="width: 100%;">
                                    <mat-label>{{ 'statementpayment.filter1label' | translate }}</mat-label>
                                    <input matInput style="outline: none;" (keyup)="applyFilterAcc($event.target.value)" #input type="number">
                                    <img matSuffix class="example-form-img"
                                      src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-5 col-6" id="due-date-filter">
                              <p>{{ 'statementpayment.filter3' | translate
                                }}</p>
                              <div class="row">
                                <div class="col">
                                   <mat-form-field appearance="outline" style="width: 100%;">
                                    <mat-label>{{ 'onlinepayment.filter3label' | translate }}</mat-label>
                                  
                                    <input matInput mask="00/00/0000" [formControl]="dueDateControl" (dateChange)="applyFilterDate($event.target.value)"
                                      [matDatepicker]="datepicker">
                                  
                                    <mat-datepicker #datepicker>
                                      <mat-datepicker-actions>
                                        <button mat-button matDatepickerCancel>
                                          {{ 'LoginModal.Cancel' | translate }}
                                        </button>
                                        <button mat-raised-button color="primary" matDatepickerApply>
                                          {{ 'LoginModal.Apply' | translate }}
                                        </button>
                                      </mat-datepicker-actions>
                                    </mat-datepicker>
                                  
                                    <span matSuffix class="date-suffix-wrapper">
                                      <mat-datepicker-toggle [for]="datepicker"></mat-datepicker-toggle>
                                      <img class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                                    </span>
                                  
                                    <!-- Error Message -->
                                    <mat-error *ngIf="dueDateControl.hasError('matDatepickerParse')">
                                      Invalid date format
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <br>

                <!-- table of StatementPayment Step 1 -->
                <div *ngIf="statementpaymentstep1">

                
                    <div class="card" style="width: 98%;">
                    <p>Step 2: Please select at least one of the invoices listed below to make a payment.</p>

                    <div style="color: red;
                    font-size: 15px;
                    font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;" *ngIf="invalid">
                        Please correct the following information.
                         <ul style="list-style-type: disc;">
                            <li *ngIf="required" style="margin-left:30px;" class="paragrapSpace" >Please supply the required information. An * indicates a required field. </li>
                            <li *ngIf="selectone" style="margin-left:30px;" class="paragrapSpace">Please select at lease one account or less than 26 accounts.</li>
                            <!-- <li  style="margin-left:30px;" class="paragrapSpace">The payment amount you have provided is not valid. </li> -->
                            <!-- <li style="margin-left:30px;" class="paragrapSpace" >A payment cannot be posted before today's date. </li>
                            <li style="margin-left:30px;" class="paragrapSpace" >The chosen payment date will make your account past due for more than 60 days. Please select an alternate date. </li>
                            <li style="margin-left:30px;" class="paragrapSpace" >Only one payment per account per day is allowed. </li>
                            <li style="margin-left:30px;" class="paragrapSpace" >The payment date that you have chosen is invalid </li>  -->
                            <li *ngIf="amount" style="margin-left:30px;" class="paragrapSpace" >The payment amount must be greater than zero and less than or equal to $2,000,000.00 </li> 
                        </ul> 
    
                    </div>
                    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                        <!--US/EN Table loading-->
                        <ng-container matColumnDef="{{column.name}}"
                            *ngFor="let column of initStatementColumns; last as isLast; first as isFirst;">
                          
                            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef
                                style=" justify-content: left;">

                                <!-- <span *ngIf="isFirst" >
                                    <mat-checkbox (click)="calculateTotalAmount()" (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                                    </mat-checkbox>
                                </span> -->
                                <div *ngIf="column.dispFormat==''" >
                                  <mat-checkbox [ngClass]="{'white-border': !isChecked}" [disabled]="selection >= 50" (click)="calculateTotalAmount()" (change)="$event ? masterToggle() : null"
                                  [checked]="selection.hasValue() && isAllSelected()"
                                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                                  </mat-checkbox>
                                </div>
                                <!-- Statement Number -->
                                <div *ngIf="column.dispFormat=='acct'" >
                                   <div class="row">{{column.display}}</div>
                                    <!-- <div class="row">
                                        <div style="display: inline-flex;">
                                            <input 
                                                style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%; height: 20px;"
                                                (keyup)="applyFilterAcc($event.target.value)" #input type="text">
                                            <mat-icon fontIcon="search">
                                            </mat-icon>
                                        </div>
                                    </div>                                         -->
                                </div>
                                <!-- Invoice Amount -->
                                <div *ngIf="column.dispFormat=='invoiceamount'">
                                   <div class="row">{{column.display}}</div> 
                                   <div class="row">
                                    <!-- <div style="display: inline-flex;">
                                        <input style="outline: none; width: 70%; margin-top: 2%; margin-bottom: 5%;  height: 20px;"
                                            (keyup)="applyFilterCurrentAmountDue($event.target.value)" #input type="text">
                                        <mat-icon fontIcon="search">
                                        </mat-icon>
                                    </div> -->
                                   </div>   
                                </div>
                                <!-- Current Due Date -->
                                <div *ngIf="column.dispFormat=='currentduedate'">
                                  <div class="row">{{column.display}}</div>  
                                    <!-- <div class="row">
                                        <div style="display: inline-flex;">
                                            <input 
                                                style="outline: none; width: 70%; height: 20px; margin-top: 4%; margin-bottom: 5%; "
                                                (keyup)="applyFilterDate($event.target.value)" #input type="date">
                                            <mat-icon fontIcon="search">
                                            </mat-icon>
                                        </div>
                                    </div> -->
                                </div>

                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="justify-content: left;">
                               
                                <span class="mobile-label">
                                  <div *ngIf="!isFrench && column.dispFormat !== ''"> {{column.display}} :</div>
                                  <div *ngIf="!isFrench && column.dispFormat==''"> {{column.display}} </div>
                                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                                </span>
                                <div *ngIf="column.dispFormat== ''">
                                  <div class="class-test">
                                    <mat-checkbox (click)="$event.stopPropagation(); calculateTotalAmount();"
                                    (change)="$event ? selection.toggle(element) : null"
                                    [checked]="selection.isSelected(element)">
                                    </mat-checkbox>
                                  </div>
                                </div>
                                 <!-- Invoice Amount -->
                                <div *ngIf="column.dispFormat== 'invoiceamount'">
                                    <!--Formats Contract String Columns-->
                                    {{element[column.name]  | currency:'USD':true:'1.2-2'}}                                 
                                </div>
                                 <!-- Statement Number -->
                                <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                                    {{element[column.name]}}
                                </div>
                                <!-- Current Due Date -->
                                <div *ngIf="column.dispFormat=='currentduedate'"> <!--Formats date Columns-->
                                  {{element[column.name] | date:'MM/dd/yyyy'}}
                                </div>                               
                            </mat-cell>
                        </ng-container>

                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="invoiceRes">
                            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                                [attr.colspan]="displayedStatementColumns.length">
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedStatementColumns"></mat-header-row>
                        <mat-row *matRowDef="let element; columns: displayedStatementColumns;" class="example-element-row"
                            [class.example-expanded-row]="invoiceRes === element"
                            (click)="invoiceRes = invoiceRes === element ? null : element">
                        </mat-row>
                        <mat-row *matRowDef="let row; columns: ['invoiceRes']"
                            class="example-detail-row"></mat-row>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter
                              
                            </td>
                            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                               </td>
                        </tr>

                    </mat-table>
                    <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
                  </div>
                  <br>

                <div class="total-amount-wrapper && tile" style="margin-right: 18px;">
                        <div>                
                          <mat-form-field appearance="outline" style="width: 100%;">
                            <mat-label>{{ 'statementpayment.select2' | translate }}<span style="color: darkred;">*</span></mat-label>
                            <input matInput [value]="totalAmount | currency: USD:true:'1.2-2'" readonly/>                                          
                          </mat-form-field>
                        </div>

                        <button type="submit" class="mbfs-button submit-button" (click)="onSubmit()">
                          {{ 'statementpayment.submit' | translate }}
                        </button>
                      </div>
                </div>

                
                 <!-- StatementPayment Step 2 on click of Submit Payment-->
                <div *ngIf="statementpaymentstep2">
                  <div class="card">
                  <div style="display: flex;">
                    <div class="row">
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                           <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'statementpayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                           <input matInput  [value]="totalAmount | currency: USD" readonly/>                                          
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
                        <!--US/EN Table loading-->
                        <ng-container matColumnDef="{{column.name}}"
                          *ngFor="let column of initStatementColumnsStep2; last as isLast; first as isFirst;">
                          <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center;">
                            <div> {{column.display}}</div>
                          </mat-header-cell>
                          <mat-cell *matCellDef="let element" style="justify-content: center;">
                            <span class="mobile-label">
                              <div> {{column.display}} :</div>
                            </span>
                            <div *ngIf="column.dispFormat=='invoiceamount'"> <!--Formats Contract String Columns-->
                               {{element[column.name]   | currency:'USD':true:'1.2-2' }}
                            </div>
                            <div *ngIf="column.dispFormat=='acct'"> <!--Formats String Columns-->
                              {{element[column.name]}}
                            </div>
                            <div *ngIf="column.dispFormat=='currentduedate'"> <!--Formats date Columns-->
                             {{ this.currentDates | date:'MM/dd/yyyy' }}
                            </div>                     
                          </mat-cell>
                        </ng-container>
          
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="selectedInvoiceResponseList">
                          <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                            [attr.colspan]="displayedStatementColumnsStep2.length">
                          </mat-cell>
                        </ng-container>
          
                        <mat-header-row *matHeaderRowDef="displayedStatementColumnsStep2"></mat-header-row>
                        <mat-row *matRowDef="let element; columns: displayedStatementColumnsStep2;" class="example-element-row"
                          [class.example-expanded-row]="selectedInvoiceResponseList === element"
                          (click)="selectedInvoiceResponseList = selectedInvoiceResponseList === element ? null : element">
                        </mat-row>
                        <mat-row *matRowDef="let row; columns: ['selectedInvoiceResponseList']" class="example-detail-row"></mat-row>
          
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                          <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                            "{{input.value}}"</td>
                        </tr>
          
                      </mat-table>
                      <br>
                    </div>
                      <br>
                      <p style="margin-left: 10px; font-weight: bold;"> Please review the following Authorization Statement before submitting your payment for processing.</p>
                      <br>
                      <div class="card">
                    <p style="padding: 10px; text-align:justify ;">
                      {{ 'onlinepayment.auth' | translate }}
                    <br><br>
                     <span style="font-weight: bold;">Notice:</span> The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.	
                    </p>
                  </div>
                    <br>
                    <mat-checkbox class="example-margin" [(ngModel)]="isChecked">
                      <label style="margin: 0px;">I have read and accept the terms of the above Authorization Statement.</label>   
                    </mat-checkbox> 
                    <br>
                    <br>
                     <div style="display:flex;flex-direction: row;gap:10px" >
                     <div *ngIf="agentview ==='true'">
                      <button class="mbfs-button" disabled>Authorize</button>
                     </div>
                      <div *ngIf="agentview !='true'">
                        <button class="mbfs-button" [disabled]="!isChecked || !this.tableLoaded" (click)="StatementPaymentAuthorize()">Authorize</button>
                      </div>
                    
                    <button class="mbfs-button" (click)="back2step1()">Cancel</button>
                     </div>
                </div>
                 <!-- StatementPayment Step 3 on click of Authorize-->
                <div *ngIf="statementpaymentstep3">
                  <div class="card">
                    <p style="font-weight: bold;"> Thank you for using the Online Payment Service. Please click "Print" to print your authorization(s) and retain them for your records.</p>
                    <div style="display: flex;">
                      <div class="row">
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>Selected Bank Profile<span style="color: red;">*</span></mat-label>
                             <input matInput  [value]="getSelectedBankName()" readonly/>                                          
                          </mat-form-field>
                        </div>
                        <div class="col">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'statementpayment.select2' | translate }}<span style="color: red;">*</span></mat-label>
                             <input matInput  [value]="totalAmount | currency: USD" readonly/>                                          
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="failureError" style="color: red;
                                              font-size: 15px;
                                              font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                      We are currently experiencing technical difficulties, Please try again later.
                    </div>
                    <br>

                    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort style="pointer-events: none;">
                        <!--US/EN Table loading-->
                        <ng-container matColumnDef="{{column.name}}"
                          *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                          <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="pointer-events: none;">
                            <div> {{column.display}}</div>
                          </mat-header-cell>
                          <mat-cell *matCellDef="let element" style="pointer-events: none;">
                            <span class="mobile-label">
                              <div> {{column.display}} :</div>
                            </span>
                            <div *ngIf="column.dispFormat=='invoiceamount'"> <!--Formats Contract String Columns-->
                              {{element[column.name]   | currency:'USD':true:'1.2-2'}}
                            </div>
                            <div *ngIf="column.dispFormat=='acct'"> <!--Formats Contract String Columns-->
                              {{element[column.name]}}
                            </div>
                            <div *ngIf="column.dispFormat=='transaction'" style="color: blue;"> <!--Formats String Columns-->
                              {{this.reference}}
                            </div>
                            <div *ngIf="column.dispFormat=='status'"> <!--Formats String Columns-->
                              {{this.status}}
                            </div>
                            <div *ngIf="column.dispFormat=='currentduedate'"> <!--Formats date Columns-->
                              {{ this.paymentDate | date:'MM/dd/yyyy' }}
                            </div>                     
                          </mat-cell>
                        </ng-container>
          
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="selectedInvoiceResponseList">
                          <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                            [attr.colspan]="displayedColumns.length">
                          </mat-cell>
                        </ng-container>
          
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                          [class.example-expanded-row]="selectedInvoiceResponseList === element"
                          (click)="selectedInvoiceResponseList = selectedInvoiceResponseList === element ? null : element">
                        </mat-row>
                        <mat-row *matRowDef="let row; columns: ['selectedInvoiceResponseList']" class="example-detail-row"></mat-row>
          
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                          <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
                          <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                            "{{input.value}}"</td>
                        </tr>
          
                      </mat-table>
                      <br>
                    </div>
                    <br>
                    <button class="mbfs-button" (click)="DownloadPdf()">Print</button>
                    <button class="mbfs-button" (click)="BacktoDashBoard()">Done</button>
                </div>
            </div>
        </div>
    </div>
</div>